module.exports = __webpack_public_path__ + "static/img/resume-material-dark.451a6ed.png";